import { CURRENCIES } from '../consts';

const POSITIONS = {
	LEFT: 'left',
	RIGHT: 'right',
};

export const CURRENCY_POSITION = {
	[CURRENCIES.USD]: POSITIONS.LEFT,
};

export const currencyFormatter = (
	value: number | string,
	currency = CURRENCIES.USD,
): string => {
	if (CURRENCY_POSITION[currency] === POSITIONS.LEFT) {
		return `${currency}${value}`;
	}
	return `${value}${currency}`;
};
